import {
  ActiveIndicator,
  ContainerIconList,
  LiItem,
  LogoImg,
  TitleIconHeaderContainer,
  TitleItemHeader,
} from "../style/style";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ChildItem, SidebarItem } from "../interface";

export const ItemListHeader = (props: {
  hideList: (id: string) => void;
  selectedItem?: (item: ChildItem | SidebarItem) => void;
  item: SidebarItem;
  isHiddenList: Record<string, boolean>;
  isHidden?: boolean;
  activeItem?: string | null;
}) => {
  const isActive = props.activeItem === props.item.id;

  // Check if this item or any of its children are active
  const isItemOrChildActive =
    isActive ||
    (props.item.children &&
      props.item.children.some((child) => child.id === props.activeItem));

  return (
    <LiItem
      isHidden={props.isHidden}
      isActive={isItemOrChildActive}
      color={props.item?.header?.color}
      onClick={() => {
        if (props.item.children?.length > 0) {
          props.hideList(props.item.id);
        } else {
          // This is a parent item without children (like DocPlace Sign), make it selectable
          props.selectedItem?.(props.item);
        }
      }}
    >
      <ContainerIconList>
        <LogoImg
          src={props.item?.header?.icon}
          alt={"img"}
          isActive={isItemOrChildActive}
          color={props.item?.header?.color}
        />
      </ContainerIconList>
      <TitleIconHeaderContainer isHidden={props.isHidden}>
        <TitleItemHeader isActive={isItemOrChildActive}>
          {props.item?.header?.title}
        </TitleItemHeader>
        {props.item.children?.length > 0 &&
          (props.isHiddenList[props.item.id] ? (
            <KeyboardArrowDownIcon
              fontSize={"small"}
              sx={{ color: "#3F3F46" }}
            />
          ) : (
            <KeyboardArrowUpIcon fontSize={"small"} sx={{ color: "#0076FF" }} />
          ))}
      </TitleIconHeaderContainer>
      <ActiveIndicator isActive={isItemOrChildActive} />
    </LiItem>
  );
};
